<div class="container-fluid p-3">

  <div class="d-flex gap-1">

    <mat-form-field appearance="outline" >
      <mat-label>Enter a date range</mat-label>
      <mat-date-range-input  [rangePicker]="picker">
        <input matStartDate [(ngModel)]="start" placeholder="Start date">
        <input matEndDate [(ngModel)]="end" placeholder="End date">
      </mat-date-range-input>
      <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>

    </mat-form-field>&nbsp;
    <mat-form-field appearance="outline">
      <mat-label >Centre Name</mat-label>
      <mat-select  aria-label="Default select example" [formControl]="SelectCentre" (selectionChange)="fetchByCenter($event)">
        <mat-option  value="All">All Centres</mat-option>
        <mat-option *ngFor="let c of (centres$ | async)" [value]="c.centreCode">{{c.centreName}}</mat-option>
      </mat-select>
    </mat-form-field>


    <mat-form-field  appearance="outline" >
      <mat-label  >Session Type</mat-label>
      <mat-select [(value)]="mSession" >
        <mat-option  value="All">All</mat-option>

        <mat-option *ngFor="let t of sessionTypes"  [value]="t">{{t}}</mat-option>

      </mat-select>
    </mat-form-field>

    <mat-form-field  appearance="outline" >
      <mat-label  >Teacher</mat-label>
      <mat-select [(value)]="mTeacher" >
        <mat-option  value="All">All</mat-option>

        <mat-option *ngFor="let t of teachers$|async"  [value]="t.userName">{{t.userName}}</mat-option>

      </mat-select>
    </mat-form-field>

    <button mat-mini-fab (click)="search()" color="accent"><mat-icon>search</mat-icon></button>
    <button mat-mini-fab (click)="clearAll()" color="accent"><mat-icon>clear</mat-icon></button>

  </div>

  <section class="card">
    <div class="ngxTableHeader">
      <ul class="header-buttons-left ms-0 mb-0">
        <li class="dropdown">
          <h2>Education Highlights</h2>
        </li>
        <li class="dropdown m-l-20">
          <label for="search-input"><i class="material-icons search-icon">search</i></label>
          <input placeholder="Search" id="search-input" type="text" class="browser-default search-field"
                 (keyup)='applyFilter($event)' aria-label="Search box" #input>
        </li>
      </ul>
      <ul class="header-buttons mr-2">
        <li>
          <button mat-mini-fab color="accent" (click)="downloadExcel()" matTooltip="Download Excel">
            <mat-icon>download</mat-icon>
          </button>
        </li>
      </ul>
    </div>
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate">Please wait Data is loading... </mat-progress-bar>

    <table mat-table [dataSource]="dataSource" matSort>

      <ng-container matColumnDef="sr.no">
        <th mat-header-cell *matHeaderCellDef> Sr.No. </th>
        <td mat-cell *matCellDef="let element; let i=index" class="truncate-text"> {{i+1}} </td>
      </ng-container>

      <!-- Source Column -->
      <ng-container matColumnDef="source">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Source </th>
        <td mat-cell *matCellDef="let element" class="truncate-text">
          <mat-chip-list>
            <mat-chip [color]="element._source === 'Follow-Up' ? 'accent' : 'primary'" selected style="font-size:11px; min-height:20px; padding:2px 8px;">
              {{element._source || 'Individual'}}
            </mat-chip>
          </mat-chip-list>
        </td>
      </ng-container>

      <!-- Position Column -->
      <ng-container matColumnDef="position">
        <th mat-header-cell *matHeaderCellDef> No. </th>
        <td mat-cell *matCellDef="let element" class="truncate-text"> {{element.position}} </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="childName" >
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Name </th>
        <td mat-cell *matCellDef="let element" [matTooltip]="element.id" class="truncate-text">{{element.childName}} </td>
      </ng-container>

      <!-- Weight Column -->
      <ng-container matColumnDef="centreName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Centre </th>
        <td mat-cell *matCellDef="let element" [matTooltip]="element.centreCode" matTooltipPosition="above" class="truncate-text">{{element.centreName}} </td>
      </ng-container>

      <!-- Symbol Column -->
      <ng-container matColumnDef="sessionDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Date</th>
        <td mat-cell *matCellDef="let element" class="truncate-text">
          {{ element.sessionDate?.toDate ? (element.sessionDate.toDate() | date : 'dd/MM/yyyy') : '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="startTime">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Timing</th>
        <td mat-cell *matCellDef="let element" [matTooltip]="getTime(element?.startTime)"  matTooltipPosition="above" class="truncate-text"><span *ngIf="element.startTime!=null && element.startTime!='' ">  {{getTime(element?.startTime)}} </span> </td>
      </ng-container>
      <ng-container matColumnDef="sessionType">
        <th mat-header-cell *matHeaderCellDef  mat-sort-header>Type of Session</th>
        <td mat-cell *matCellDef="let element" [matTooltip]="element.sessionType"  matTooltipPosition="above" class="truncate-text">{{element.sessionType}}  </td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let element" [matTooltip]="getTooltip(element)"  matTooltipPosition="above" class="truncate-text" matTooltipClass="custom-tooltip"> {{element.status||'Pending'}} </td>
      </ng-container>
      <ng-container matColumnDef="submittedBy">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Teacher</th>
        <td mat-cell *matCellDef="let element" [matTooltip]="element.submittedBy"  matTooltipPosition="above" class="truncate-text">{{element.submittedBy}}  </td>
      </ng-container>
      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Created At </th>
        <td mat-cell *matCellDef="let element" > <span *ngIf='element.createdAt' [matTooltip]="getDateandTime(element.createdAt)"  matTooltipPosition="above" class="truncate-text" >{{getDateandTime(element.createdAt)}}</span> </td>
      </ng-container>
      <ng-container matColumnDef="present">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Attendance </th>
        <td mat-cell *matCellDef="let element">
          {{ element._source === 'Follow-Up' ? 'N/A' : getPresent(element) }}
        </td>
      </ng-container>
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>Action</th>
        <td mat-cell *matCellDef="let element">
          <div class="d-flex">
            <button permission="Education Highlight" [permissionTypes]="[PermissionType.ALL, PermissionType.VIEW]" mat-icon-button color="accent" (click)="viewDialog(element)" matTooltip="View">

              <mat-icon>remove_red_eye</mat-icon>
            </button>
          </div>

        </td>
      </ng-container>

      <!-- Expand toggle column -->
      <ng-container matColumnDef="expand">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element" style="width:40px;text-align:center;">
          <mat-icon style="cursor:pointer;color:#555;transition:transform 0.2s;"
                    [style.transform]="expandedElement === element ? 'rotate(180deg)' : 'rotate(0deg)'"
                    [matTooltip]="expandedElement === element ? 'Collapse' : 'View Remark'">
            expand_more
          </mat-icon>
        </td>
      </ng-container>

      <!-- Expandable detail row — remark area -->
      <ng-container matColumnDef="detail">
        <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length" style="padding:0;border-bottom:none;">
          <div @detailExpand class="remark-detail-panel">

            <!-- Individual: show remark -->
            <ng-container *ngIf="element._source !== 'Follow-Up'">
              <ng-container *ngIf="element.remark; else noRemark">
                <p class="remark-label">
                  <mat-icon>comment</mat-icon> Remark
                </p>
                <p class="remark-value">{{ element.remark }}</p>
              </ng-container>
              <ng-template #noRemark>
                <em class="text-muted">No remark recorded for this session.</em>
              </ng-template>
            </ng-container>

            <!-- Follow-Up: show last question remark -->
            <ng-container *ngIf="element._source === 'Follow-Up'">
              <ng-container *ngIf="element.questions?.length > 0; else noFuRemark">
                <p class="remark-label">
                  <mat-icon>comment</mat-icon> Remark / Last Question
                </p>
                <div class="fu-question">
                  <p class="mb-1 fw-bold">{{ element.questions[element.questions.length - 1].question }}</p>
                  <p class="mb-1">
                    <span class="ans-badge">{{ element.questions[element.questions.length - 1].ans }}</span>
                  </p>
                  <p class="remark-value mb-0" *ngIf="element.questions[element.questions.length - 1].remark">
                    {{ element.questions[element.questions.length - 1].remark }}
                  </p>
                </div>
              </ng-container>
              <ng-template #noFuRemark>
                <em class="text-muted">No questions recorded for this follow-up.</em>
              </ng-template>
            </ng-container>

          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"
          (click)="toggleExpand(row)"
          class="hl-main-row"
          [class.hl-expanded-row]="expandedElement === row"></tr>
      <!-- Detail row — only inserted into DOM when row is expanded -->
      <tr mat-row *matRowDef="let row; columns: ['detail']; when: isExpandedRow"
          class="hl-detail-row"></tr>

    </table>
    <mat-paginator [pageSizeOptions]="[25,50,100,200,250,500,1000]" aria-label="Select page of users"></mat-paginator>

  </section>
</div>

